










































import { Component, Vue } from 'vue-property-decorator'
import { t } from '@/language'
import { Load } from '@/units'
import { isObjectEmpty } from '@/utils'

@Component
export default class Nav extends Vue {
  constructor () {
    super()

    console.info('📦 [Nav] componentDidMount....')
  }

  // __METHODS
  private trans (val: string): void {
    if (val) {
      t(val)
    }
  }

  private href (val: any): any {
    const results: any = { name: val.href }
    if (!isObjectEmpty(val.params)) {
      results.params = val.params
    }
    return results
  }

  private async destroy () {
    Load(this, true)

    const res: any = await this.$store.dispatch('APP.AUTH/logout')
    if (res) {
      this.$router.push({ name: 'auth' })
    }

    Load(this, false)
  }

  // __COMPUTED
  private get navs (): any {
    const user: any = this.$store.getters['APP.AUTH/user']
    const menu: any = require('./menu.json')

    for (const x of menu) {
      if (['users', 'cog'].indexOf(x.href) > -1) {
        x.hasPermission = Boolean(user.isAdmin)
      }
    }

    return menu.filter((h: any) => h.hasPermission)
  }

  private get langs (): any {
    const langs: any = require('@/language/data.json')
    const locale: string = this.$i18n.locale

    for (const lang of langs) {
      lang.focus = Boolean(lang.locale === locale)
    }
    
    return langs
  }
}
